import {ReactElement, ReactNode} from "react";
import {ErrorBoundary} from "react-error-boundary";
import styled, {css} from "styled-components";

import {HookFormContextProvider} from "@/context/HookFormContext";
import {LogContextProvider} from "@/context/LogContex";
import {breakpoints} from "@/GlobalStyle";

import {ErrorMessage} from "../ErrorMessage/ErrorMessage";
import {Footer} from "./Footer/Footer";
import {Header} from "./Header/Header";
import {ModuleSelectCampagneContremarque} from "./ModuleSelectCampagneContremarque/ModuleSelectCampagneContremarque";

const LayoutStyled = styled.main`
  min-height: calc(100vh - 233px);
  max-width: 1440px;
  padding: 70px 50px 0 50px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 0;
  margin-bottom: 40px;
  @media (max-width: ${breakpoints.md}) {
    padding: 70px 20px 20px 20px;
  }
`;

const Content = styled.div<{$moduleIsVisible: boolean}>`
  margin-top: 30px;
  width: 100%;
  ${({$moduleIsVisible}) =>
    $moduleIsVisible
      ? css`
          min-height: calc(100vh - 423px);
        `
      : css`
          min-height: calc(100vh - 263px);
        `}
`;

export function Layout({
  children,
  moduleSelectCampagneContremarqueProps = {
    moduleSelectIsVisible: true,
    moduleSelectNeedContremarque: true,
    lockCampagne: false,
    lockContremarque: false,
  },
}: {
  children: ReactNode;
  moduleSelectCampagneContremarqueProps?: {
    moduleSelectIsVisible: boolean;
    moduleSelectNeedContremarque: boolean;
    lockCampagne: boolean;
    lockContremarque: boolean;
  };
}): ReactElement {
  return (
    <LogContextProvider>
      <Header />
      <LayoutStyled>
        <ErrorBoundary
          fallback={
            <ErrorMessage
              text="Une erreur est survenu, veuillez réessayer"
              buttonToRefresh={true}
            />
          }>
          {moduleSelectCampagneContremarqueProps?.moduleSelectIsVisible ? (
            <HookFormContextProvider>
              <ModuleSelectCampagneContremarque
                {...moduleSelectCampagneContremarqueProps}
              />
            </HookFormContextProvider>
          ) : null}
          <Content
            $moduleIsVisible={
              moduleSelectCampagneContremarqueProps?.moduleSelectIsVisible
            }>
            {children}
          </Content>
        </ErrorBoundary>
      </LayoutStyled>
      <Footer />
    </LogContextProvider>
  );
}
